import { render, staticRenderFns } from "./KitaOrSchuleModal.vue?vue&type=template&id=77e145e5&"
import script from "./KitaOrSchuleModal.vue?vue&type=script&lang=js&"
export * from "./KitaOrSchuleModal.vue?vue&type=script&lang=js&"
import style0 from "./KitaOrSchuleModal.vue?vue&type=style&index=0&id=77e145e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports